export default __webpack_public_path__ + "static/media/potrait Preview.cdead574.jpeg";